import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { selectCadastralNumbers } from '../../../selectors/offer/selectCadastralNumbers';
import { ECadastralFieldsNames } from '../../../types/reducers/rosreestrData';

interface IParams {
  validateField: (
    name: ECadastralFieldsNames,
    value: string,
    isSubmitted?: boolean,
  ) => { name: ECadastralFieldsNames; value: string };
}

/** Валидация полей при загрузке формы (в режиме редактирования) */
export const useValidateOnLoad = ({ validateField }: IParams) => {
  const cadastralNumbers = useSelector(selectCadastralNumbers, shallowEqual);

  useEffect(() => {
    Object.entries(cadastralNumbers)
      .filter(([, value]) => !!value)
      .map(([key, value]) => {
        validateField(key as ECadastralFieldsNames, value as string);
      });
  }, []); // eslint-disable-line
};
